import * as tslib_1 from "tslib";
// Core packages
import { formatDate } from "@angular/common";
import { OnDestroy, OnInit } from "@angular/core";
// Third party packages
import { MatDialog, MatExpansionPanel, MatSort } from "@angular/material";
import { TranslateService } from "@ngx-translate/core";
import { Workbook } from "exceljs";
import * as FileSaver from "file-saver";
import moment from "moment";
import { CookieService } from "ngx-cookie-service";
import { ToastrService } from "ngx-toastr";
import { take } from "rxjs/operators";
// Custom packages
import { AuthService } from "src/app/modules/auth/auth.service";
import { CompaniesService } from "src/app/modules/companies/companies.service";
import { DocumentArchivesService } from "src/app/modules/properties/document-archives.service";
import { SearchDocsService } from "src/app/modules/search-docs/search-docs.service";
import { SettingsService } from "src/app/modules/settings/settings.service";
import { SuppliersService } from "src/app/modules/suppliers/suppliers.service";
import { ApiService } from "src/app/shared/services/api.service";
import { ConfigService } from "src/app/shared/services/config.service";
import { HelperService } from "src/app/shared/services/helper.service";
import DocumentTypeStructure from "../../../properties/documentTypes";
import { CompanySearchComponent } from "../../components/company-search/company-search.component";
import { SupplierSearchComponent } from "../../components/supplier-search/supplier-search.component";
import { CancelContractDialogComponent } from "src/app/modules/properties/components/cancel-contract-dialog/cancel-contract-dialog.component";
import { PropertyExpireContractItemDialogComponent } from "src/app/modules/properties/components/contract-expire-item-dialog/contract-expire-item-dialog.component";
import { DocumentDownloadDialogComponent } from "src/app/modules/properties/components/document-download-dialog/document-download-dialog.component";
import { PropertyDetailDocumentItemDialogComponent } from "src/app/modules/properties/components/document-item-dialog/document-item-dialog.component";
import { ConfirmDialogComponent } from "src/app/shared/components/dialogs/confirm-dialog/confirm-dialog.component";
var SearchDocsListV2Component = /** @class */ (function () {
    /**
     * Class constructor
     */
    function SearchDocsListV2Component(configService, toastrService, translateService, authService, companiesService, dialog, cookieService, searchDocsService, apiService, // DO NOT MOVE since it's used for 'autocomplete' field type,
    settingsService, documentArchivesService, suppliersService, helperService, cancelContractDialog) {
        this.configService = configService;
        this.toastrService = toastrService;
        this.translateService = translateService;
        this.authService = authService;
        this.companiesService = companiesService;
        this.dialog = dialog;
        this.cookieService = cookieService;
        this.searchDocsService = searchDocsService;
        this.apiService = apiService;
        this.settingsService = settingsService;
        this.documentArchivesService = documentArchivesService;
        this.suppliersService = suppliersService;
        this.helperService = helperService;
        this.cancelContractDialog = cancelContractDialog;
        this.subscriptions = [];
        this.lang = this.translateService.currentLang || this.translateService.defaultLang;
        this.loggedUserMaster = false;
        // Section
        this.step = 1;
        // Company
        this.companySelected = "";
        // Properties
        this.propertiesIsLoading = true;
        this.properties = [];
        this.displayProperties = [];
        this.propertySearchValue = "";
        this.propertyCodeSearchValue = "";
        this.selectAllProperties = false;
        this.someSelectedProperties = false;
        // Area
        this.selectedArea = "";
        this.documentTypeStructure = new DocumentTypeStructure();
        this.documentTemplateId = "";
        this.documentTemplate = [];
        this.topics = [];
        this.selectAllTopics = false;
        this.someSelectedTopics = false;
        // Subtopic
        this.subtopics = [];
        this.selectAllSubtopics = false;
        this.someSelectedSubtopics = false;
        // Documents
        this.documents = [];
        this.docSearchValue = "";
        this.displayDocs = [];
        this.selectAllDocuments = false;
        this.selectMandatoryDocuments = false;
        // Supplier
        this.supplierId = "";
        this.supplierName = "";
        // Date
        this.dateFrom = undefined;
        this.dateTo = undefined;
        // Protocol
        this.protocolValue = "";
        // Keyword
        this.keywordValue = "";
        // BEGIN - Result table
        this.displayedColumns = [
            "index",
            "property",
            "masterCode",
            "docType",
            "structure",
            "content",
            "reference",
            "documentDate",
            "expirationDate",
            "barCode",
            "actions",
        ];
        this.results = [];
        this.dataSource = [];
        this.resulIsLoading = false;
        this.canExport = false;
        this.showDocumentsExpired = true;
        this.showDocumentsMandatory = true;
        // END - Result table
        // Show / Edit document
        // Dati aggiuntivi elenco/nuovo elemento
        this.suppliersName = [];
        this.yearsOfStorage = [];
        this.conductorName = [];
        this.nameInterventionArchiving = [];
    }
    /**
     * Init components
     *
     * @since 1.0.0
     */
    SearchDocsListV2Component.prototype.ngOnInit = function () {
        var _this = this;
        // Get current lang
        this.lang =
            this.cookieService.get("lang") || this.configService.defaultLang;
        // Get logged user data
        this.subscriptions.push(this.authService.loggedUser$.subscribe(function (res) {
            _this.loggedUser = res;
            _this.currentRole = _this.loggedUser.userRoles.find(function (obj) {
                return (obj._id.toString() ===
                    _this.authService.loggedUserRequestedRole$.getValue().toString());
            });
            if (_this.currentRole.role.type === "master" ||
                _this.currentRole.role.type === "collaborator") {
                _this.loggedUserMaster = true;
            }
        }));
        this.subscriptions.push(this.authService.loggedUserPermissions$.subscribe(function (res) { return (_this.loggedUserPermissions = res); }));
        // Get logged user's role data
        this.currentRole = this.authService.loggedUserRequestedRoleType$.getValue();
        if (this.currentRole !== "admin" && this.currentRole !== "operator") {
            this.companySelected = this.cookieService.get("requestedCompany");
        }
        this.subscriptions.push(this.companiesService
            .shouldShowMasterCodeColumn$(this.currentRole, this.companySelected)
            .subscribe(function (show) {
            if (!show) {
                var masterCodeIndex = _this.displayedColumns.findIndex(function (el) { return el === "masterCode"; });
                if (masterCodeIndex > -1) {
                    _this.displayedColumns.splice(masterCodeIndex, 1);
                }
            }
        }));
        this.propertiesIsLoading = true;
        this.subscriptions.push(this.searchDocsService.getSearchDocsProperties().subscribe(function (res) {
            var e_1, _a;
            var items = (res.data && res.data.items) ||
                (Array.isArray(res.data) ? res.data : null);
            if (res.status && items && Array.isArray(items)) {
                try {
                    for (var items_1 = tslib_1.__values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
                        var item = items_1_1.value;
                        _this.properties.push({
                            checked: false,
                            id: item._id,
                            name: item.name,
                            masterCode: item.masterCode,
                        });
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                _this.displayProperties = JSON.parse(JSON.stringify(_this.properties));
                setTimeout(function () {
                    _this.propertiesIsLoading = false;
                    return;
                }, 500);
            }
            else {
                _this.toastrService.error(res.message);
                setTimeout(function () {
                    _this.propertiesIsLoading = false;
                    return;
                }, 500);
            }
        }));
        this.subscriptions.push(this.settingsService.getDocument().subscribe(function (res) {
            if (res.status) {
                if (res.data &&
                    Array.isArray(res.data) &&
                    res.data.length > 0 &&
                    res.data[0].area &&
                    Array.isArray(res.data[0].area)) {
                    _this.documentTemplateId = res.data[0]._id;
                    _this.documentTemplate = res.data[0].area;
                }
            }
        }, function (err) {
            //
        }));
        this.subscriptions.push(this.sort.sortChange.subscribe(function () { return _this.sortData(); }));
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    SearchDocsListV2Component.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    /**
     * Handle seciont focused
     */
    SearchDocsListV2Component.prototype.OnSectionFocused = function (step) {
        if (!this.propertiesIsLoading && this.someSelectedProperties) {
            this.step = step;
        }
    };
    /**
     * Handle company selected
     */
    SearchDocsListV2Component.prototype.OnCompanySelected = function (event) {
        var _this = this;
        if (event) {
            this.companySelected = event;
            this.propertiesIsLoading = true;
            this.subscriptions.push(this.searchDocsService
                .getSearchDocsProperties(event)
                .subscribe(function (res) {
                var e_2, _a;
                var items = (res.data && res.data.items) ||
                    (Array.isArray(res.data) ? res.data : null);
                if (res.status && items && Array.isArray(items)) {
                    _this.properties = [];
                    _this.selectAllProperties = false;
                    try {
                        for (var items_2 = tslib_1.__values(items), items_2_1 = items_2.next(); !items_2_1.done; items_2_1 = items_2.next()) {
                            var item = items_2_1.value;
                            _this.properties.push({
                                checked: false,
                                id: item._id,
                                name: item.name,
                                masterCode: item.masterCode,
                            });
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (items_2_1 && !items_2_1.done && (_a = items_2.return)) _a.call(items_2);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                    _this.displayProperties = JSON.parse(JSON.stringify(_this.properties));
                    setTimeout(function () {
                        _this.propertiesIsLoading = false;
                        return;
                    }, 500);
                }
                else {
                    _this.toastrService.error(res.message);
                    setTimeout(function () {
                        _this.propertiesIsLoading = false;
                        return;
                    }, 500);
                }
            }));
        }
    };
    /**
     * Handle filter on properties
     *
     * @since 1.0.0
     */
    SearchDocsListV2Component.prototype.applyFilterProperties = function (event) {
        this.propertySearchValue = event.target.value;
        this.applyPropertiesFilters();
    };
    /**
     * Handle filter on properties by master code
     *
     * @since 1.0.0
     */
    SearchDocsListV2Component.prototype.applyFilterPropertyCode = function (event) {
        this.propertyCodeSearchValue = event.target.value;
        this.applyPropertiesFilters();
    };
    /**
     * Apply the combined name/code filters to the loaded properties list
     *
     * @since 1.0.0
     */
    SearchDocsListV2Component.prototype.applyPropertiesFilters = function () {
        var nameNeedle = this.propertySearchValue.trim().toLowerCase();
        var codeNeedle = this.propertyCodeSearchValue.trim().toLowerCase();
        var filteredProperties = this.properties.filter(function (el) {
            return (el.name || "").toLowerCase().indexOf(nameNeedle) !== -1 &&
                (el.masterCode || "").toLowerCase().indexOf(codeNeedle) !== -1;
        });
        this.displayProperties = JSON.parse(JSON.stringify(filteredProperties));
    };
    /**
     * Handle select all properties
     *
     * @since 1.0.0
     */
    SearchDocsListV2Component.prototype.onSelectAllProperties = function (checked) {
        this.selectAllProperties = checked;
        this.displayProperties.forEach(function (el) { return (el.checked = checked); });
        this.someSelectedProperties = checked;
    };
    /**
     * Handle select property
     *
     * @since 1.0.0
     */
    SearchDocsListV2Component.prototype.onSelectProperty = function () {
        this.someSelectedProperties = this.displayProperties.some(function (el) { return el.checked; });
    };
    /**
     * Get selected area
     *
     * @since 1.0.0
     */
    SearchDocsListV2Component.prototype.onChangeArea = function () {
        var e_3, _a;
        var _this = this;
        this.topics = [];
        this.subtopics = [];
        this.docSearchValue = "";
        this.displayDocs = [];
        this.selectAllTopics = false;
        this.selectAllSubtopics = false;
        this.selectAllDocuments = false;
        this.selectMandatoryDocuments = false;
        if (typeof this.selectedArea === "undefined" || this.selectedArea === "") {
            return;
        }
        var subArea = this.documentTemplate.filter(function (elem) {
            return elem.group === _this.selectedArea;
        });
        if (subArea && Array.isArray(subArea)) {
            try {
                for (var subArea_1 = tslib_1.__values(subArea), subArea_1_1 = subArea_1.next(); !subArea_1_1.done; subArea_1_1 = subArea_1.next()) {
                    var item = subArea_1_1.value;
                    this.topics.push({
                        checked: false,
                        code: item.code,
                        name: this.lang === "it" ? item.translation.it : item.translation.en,
                    });
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (subArea_1_1 && !subArea_1_1.done && (_a = subArea_1.return)) _a.call(subArea_1);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
        this.topics.sort(function (a, b) {
            if (a.name > b.name) {
                return 1;
            }
            else if (a.name < b.name) {
                return -1;
            }
            else {
                return 0;
            }
        });
    };
    /**
     * Handle select topic
     *
     * @since 1.0.0
     */
    SearchDocsListV2Component.prototype.onSelectTopic = function (item, event) {
        var e_4, _a;
        if (event) {
            var selectedTopicContent = this.documentTypeStructure.getDocumentTopic2(item.code, this.documentTemplate);
            if (selectedTopicContent && Array.isArray(selectedTopicContent)) {
                try {
                    for (var selectedTopicContent_1 = tslib_1.__values(selectedTopicContent), selectedTopicContent_1_1 = selectedTopicContent_1.next(); !selectedTopicContent_1_1.done; selectedTopicContent_1_1 = selectedTopicContent_1.next()) {
                        var el = selectedTopicContent_1_1.value;
                        this.subtopics.push({
                            checked: false,
                            parent: el.parent,
                            type: el.rawTitle,
                            code: el.code,
                            name: this.lang === "it" ? el.translation.it : el.translation.en,
                        });
                    }
                }
                catch (e_4_1) { e_4 = { error: e_4_1 }; }
                finally {
                    try {
                        if (selectedTopicContent_1_1 && !selectedTopicContent_1_1.done && (_a = selectedTopicContent_1.return)) _a.call(selectedTopicContent_1);
                    }
                    finally { if (e_4) throw e_4.error; }
                }
            }
        }
        else {
            // remove subtopics and docs
            var subTopic_1 = this.subtopics.find(function (el) { return el.parent === item.code; });
            this.displayDocs = this.displayDocs.filter(function (el) { return el.parent !== subTopic_1.code; });
            this.documents = this.documents.filter(function (el) { return el.parent !== subTopic_1.code; });
            this.subtopics = this.subtopics.filter(function (el) { return el.parent !== item.code; });
        }
        this.someSelectedTopics = this.topics.some(function (el) { return el.checked; });
        this.subtopics.sort(function (a, b) {
            if (a.name > b.name) {
                return 1;
            }
            else if (a.name < b.name) {
                return -1;
            }
            else {
                return 0;
            }
        });
    };
    /**
     * Handle select all topics
     *
     * @since 1.0.0
     */
    SearchDocsListV2Component.prototype.onSelectAllTopics = function (checked) {
        var e_5, _a, e_6, _b;
        this.selectAllTopics = checked;
        this.someSelectedTopics = checked;
        if (!checked) {
            this.subtopics = [];
            this.docSearchValue = "";
            this.displayDocs = [];
            try {
                for (var _c = tslib_1.__values(this.topics), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var el = _d.value;
                    el.checked = false;
                }
            }
            catch (e_5_1) { e_5 = { error: e_5_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_5) throw e_5.error; }
            }
        }
        else {
            try {
                for (var _e = tslib_1.__values(this.topics), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var el = _f.value;
                    el.checked = true;
                    this.onSelectTopic(el, checked);
                }
            }
            catch (e_6_1) { e_6 = { error: e_6_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                }
                finally { if (e_6) throw e_6.error; }
            }
        }
    };
    /**
     * Handle select subtopic
     *
     * @since 1.0.0
     */
    SearchDocsListV2Component.prototype.onSelectSubtopic = function (item, event) {
        var e_7, _a;
        if (event) {
            var documents = this.documentTypeStructure.getDocumentSubTopic2(item.code, item.parent, this.documentTemplate, this.condoStructure, false, this.lang);
            if (documents && Array.isArray(documents)) {
                try {
                    for (var documents_1 = tslib_1.__values(documents), documents_1_1 = documents_1.next(); !documents_1_1.done; documents_1_1 = documents_1.next()) {
                        var doc = documents_1_1.value;
                        if (!doc.deleted) {
                            this.documents.push({
                                checked: false,
                                visible: doc.visible,
                                parent: doc.parent,
                                code: doc.code,
                                title: doc.title,
                                mandatory: doc.mandatory,
                            });
                        }
                    }
                }
                catch (e_7_1) { e_7 = { error: e_7_1 }; }
                finally {
                    try {
                        if (documents_1_1 && !documents_1_1.done && (_a = documents_1.return)) _a.call(documents_1);
                    }
                    finally { if (e_7) throw e_7.error; }
                }
            }
        }
        else {
            this.documents = this.documents.filter(function (doc) { return doc.parent !== item.code; });
        }
        this.documents.sort(function (a, b) {
            if (a.title > b.title) {
                return 1;
            }
            else if (a.title < b.title) {
                return -1;
            }
            else {
                return 0;
            }
        });
        this.displayDocs = JSON.parse(JSON.stringify(this.documents));
    };
    /**
     * Handle select all subtopics
     *
     * @since 1.0.0
     */
    SearchDocsListV2Component.prototype.onSelectAllSubtopics = function (checked) {
        var e_8, _a;
        this.selectAllSubtopics = checked;
        this.someSelectedSubtopics = checked;
        this.documents = [];
        if (!checked) {
            this.docSearchValue = "";
            this.displayDocs = [];
        }
        try {
            for (var _b = tslib_1.__values(this.subtopics), _c = _b.next(); !_c.done; _c = _b.next()) {
                var el = _c.value;
                el.checked = checked;
                this.onSelectSubtopic(el, checked);
            }
        }
        catch (e_8_1) { e_8 = { error: e_8_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_8) throw e_8.error; }
        }
    };
    /**
     * Handle select all docs
     *
     * @since 1.0.0
     */
    SearchDocsListV2Component.prototype.onSelectAllDocuments = function (checked) {
        this.selectAllDocuments = checked;
        this.documents.forEach(function (el) { return (el.checked = checked); });
        this.displayDocs.forEach(function (el) { return (el.checked = checked); });
    };
    /**
     * Handle select doc
     *
     * @since 1.0.0
     */
    SearchDocsListV2Component.prototype.onSelectDoc = function (item, checked) {
        var doc = this.documents.find(function (el) { return el.code === item.code; });
        if (doc) {
            doc.checked = checked;
        }
        var displayDoc = this.displayDocs.find(function (el) { return el.code === item.code; });
        if (displayDoc) {
            displayDoc.checked = checked;
        }
    };
    /**
     * Handle show mandatory docs
     *
     * @since 1.0.0
     */
    SearchDocsListV2Component.prototype.onShowMandatoryDocuments = function (checked) {
        this.selectMandatoryDocuments = checked;
        if (checked) {
            var filteredDocs = this.documents.filter(function (el) { return el.mandatory; });
            this.displayDocs = JSON.parse(JSON.stringify(filteredDocs));
        }
        else {
            this.displayDocs = JSON.parse(JSON.stringify(this.documents));
            this.docSearchValue = "";
        }
    };
    /**
     * Handle filter on properties
     *
     * @since 1.0.0
     */
    SearchDocsListV2Component.prototype.applyFilterDocs = function (event) {
        var _this = this;
        this.docSearchValue = event.target.value;
        var regex = new RegExp(this.docSearchValue.trim().toLowerCase(), "i");
        var filteredDocs = this.documents.filter(function (el) {
            if (regex.test(el.title) &&
                (!_this.selectMandatoryDocuments ||
                    (_this.selectMandatoryDocuments && el.mandatory))) {
                return true;
            }
            return false;
        });
        this.displayDocs = JSON.parse(JSON.stringify(filteredDocs));
    };
    /**
     * Handle supplier selected
     */
    SearchDocsListV2Component.prototype.OnSupplierSelected = function (event) {
        if (event) {
            this.supplierId = event.id;
            this.supplierName = event.name;
        }
    };
    /**
     * Handle reset all filters
     */
    SearchDocsListV2Component.prototype.onResetAll = function () {
        var _this = this;
        var dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: this.translateService.instant("searchDocs.dialogs.resetAll.title"),
                message: this.translateService.instant("searchDocs.dialogs.resetAll.text"),
                btnOkText: this.translateService.instant("common.cta.confirm"),
                btnCancelText: this.translateService.instant("common.cta.close"),
            },
            width: "500px",
        });
        dialogRef.afterClosed().subscribe(function (res) {
            if (res) {
                _this.someSelectedProperties = false;
                _this.propertySearchValue = "";
                _this.propertyCodeSearchValue = "";
                _this.selectAllProperties = false;
                _this.properties = [];
                _this.selectedArea = "";
                _this.topics = [];
                _this.subtopics = [];
                _this.docSearchValue = "";
                _this.displayDocs = [];
                _this.selectAllTopics = false;
                _this.selectAllSubtopics = false;
                _this.selectAllDocuments = false;
                _this.selectMandatoryDocuments = false;
                _this.supplierId = "";
                _this.supplierName = "";
                _this.dateFrom = undefined;
                _this.dateTo = undefined;
                _this.protocolValue = "";
                _this.keywordValue = "";
                _this.supplierSearch.onResetSelected();
                if (_this.companySearch) {
                    _this.companySearch.onResetSelected();
                }
                _this.propertiesIsLoading = true;
                _this.subscriptions.push(_this.searchDocsService.getSearchDocsProperties().subscribe(function (res) {
                    var e_9, _a;
                    var items = (res.data && res.data.items) ||
                        (Array.isArray(res.data) ? res.data : null);
                    if (res.status && items && Array.isArray(items)) {
                        try {
                            for (var items_3 = tslib_1.__values(items), items_3_1 = items_3.next(); !items_3_1.done; items_3_1 = items_3.next()) {
                                var item = items_3_1.value;
                                _this.properties.push({
                                    checked: false,
                                    id: item._id,
                                    name: item.name,
                                    masterCode: item.masterCode,
                                });
                            }
                        }
                        catch (e_9_1) { e_9 = { error: e_9_1 }; }
                        finally {
                            try {
                                if (items_3_1 && !items_3_1.done && (_a = items_3.return)) _a.call(items_3);
                            }
                            finally { if (e_9) throw e_9.error; }
                        }
                        _this.displayProperties = JSON.parse(JSON.stringify(_this.properties));
                        setTimeout(function () {
                            _this.propertiesIsLoading = false;
                            return;
                        }, 500);
                    }
                    else {
                        _this.toastrService.error(res.message);
                        setTimeout(function () {
                            _this.propertiesIsLoading = false;
                            return;
                        }, 500);
                    }
                }));
                _this.step = 1;
            }
        });
    };
    /**
     * Handle rest filters except for properties
     */
    SearchDocsListV2Component.prototype.onReset = function () {
        var _this = this;
        var dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: this.translateService.instant("searchDocs.dialogs.reset.title"),
                message: this.translateService.instant("searchDocs.dialogs.reset.text"),
                btnOkText: this.translateService.instant("common.cta.confirm"),
                btnCancelText: this.translateService.instant("common.cta.close"),
            },
            width: "500px",
        });
        dialogRef.afterClosed().subscribe(function (res) {
            if (res) {
                _this.selectedArea = "";
                _this.topics = [];
                _this.subtopics = [];
                _this.docSearchValue = "";
                _this.displayDocs = [];
                _this.selectAllTopics = false;
                _this.selectAllSubtopics = false;
                _this.selectAllDocuments = false;
                _this.selectMandatoryDocuments = false;
                _this.supplierId = "";
                _this.supplierName = "";
                _this.dateFrom = undefined;
                _this.dateTo = undefined;
                _this.protocolValue = "";
                _this.keywordValue = "";
                _this.supplierSearch.onResetSelected();
                _this.step = 1;
            }
        });
    };
    /**
     * Handle supplier selected
     */
    SearchDocsListV2Component.prototype.onSubmit = function () {
        var _this = this;
        var properties = [];
        if (this.propertySearchValue !== "" ||
            this.propertyCodeSearchValue !== "" ||
            !this.selectAllProperties) {
            properties = this.displayProperties
                .filter(function (el) { return el.checked; })
                .map(function (el) { return el.id; });
        }
        else {
            properties = ["all"];
        }
        var subtopics = this.subtopics
            .filter(function (el) { return el.checked; })
            .map(function (el) { return el.type; });
        var docs = this.displayDocs
            .filter(function (el) { return el.checked; })
            .map(function (el) { return el.code; });
        // console.log(subtopics)
        // console.log("this.dateFrom", this.dateFrom)
        // console.log("moment(this.dateFrom).isValid()", moment(this.dateFrom).isValid())
        // Prepare filtering data
        var dataFilter = {
            properties: properties,
            company: this.companySelected,
            area: this.selectedArea,
            subTopics: subtopics,
            documents: docs,
            supplier: this.supplierName,
            startDate: this.dateFrom && moment(this.dateFrom).isValid()
                ? moment(this.dateFrom).local(true).toISOString()
                : undefined,
            endDate: this.dateTo && moment(this.dateTo).isValid()
                ? moment(this.dateTo).local(true).toISOString()
                : undefined,
            protocollo: this.protocolValue,
            keyword: this.keywordValue,
        };
        // this.showParameters = false;
        this.filterPanel.close();
        this.canExport = false;
        this.resulIsLoading = true;
        this.subscriptions.push(this.searchDocsService
            .getSearchDocsGeneralV2(dataFilter)
            .subscribe(function (res) {
            if (res.status) {
                _this.results = [];
                var items = (res.data && res.data.items && Array.isArray(res.data.items))
                    ? res.data.items
                    : (Array.isArray(res.data) ? res.data : []);
                if (items.length) {
                    items.forEach(function (item) {
                        var supplier = "";
                        if (item.data && item.data.ragioneSocialeFornitore) {
                            supplier = item.data.ragioneSocialeFornitore;
                        }
                        else if (item.data &&
                            item.data.nomeSocietaEroganteInServizio) {
                            supplier = item.data.nomeSocietaEroganteInServizio;
                        }
                        // this.results.push({
                        //   loaded: item.loaded ? item.loaded : "",
                        // });
                        var barCode = "";
                        if (item.data && item.data.barCode) {
                            barCode = item.data.barCode.substring(item.data.barCode.length - 5, item.data.barCode.length - 1) + " " + item.data.barCode.substring(item.data.barCode.length - 1, item.data.barCode.length);
                        }
                        _this.results.push({
                            id: item._id,
                            documentArchiveId: item.documentArchiveId,
                            propertyId: item.propertyId._id,
                            property: item.propertyId.name,
                            docType: item.type,
                            structure: item.structureObjectName,
                            structureId: item.structureObjectId,
                            content: item.data && item.data.contenutoDocumento
                                ? item.data.contenutoDocumento
                                : "",
                            reference: supplier,
                            documentDate: item.data && item.data.dataDocumento
                                ? item.data.dataDocumento
                                : "",
                            expirationDate: item.dateExpired ? item.dateExpired : "",
                            contract: item.contract,
                            expired: item.expired,
                            privacy: item.privacy,
                            mandatory: item.mandatory,
                            mockup: item.mockup ? true : false,
                            data: item.data,
                            pdfmsg: item.pdfmsg,
                            cancellationRequestDate: item.cancellationRequestDate,
                            cancellationRequestBy: item.cancellationRequestBy,
                            key: item.key,
                            docId: item.structureObjectId !== "" ? item.docId : "",
                            subDocId: item.subDocId,
                            keyTranslateTitle: "properties.documents." + item.subTopic,
                            companyCode: item.propertyId &&
                                item.propertyId.admin &&
                                item.propertyId.admin.company &&
                                item.propertyId.admin.company.code
                                ? item.propertyId.admin.company.code
                                : "",
                            propertyCode: item.propertyId && item.propertyId.code
                                ? item.propertyId.code
                                : "",
                            masterCode: item.propertyId && item.propertyId.masterCode
                                ? item.propertyId.masterCode
                                : "",
                            barCode: barCode,
                            loaded: item.loaded ? item.loaded : "",
                        });
                    });
                }
                _this.dataSource = JSON.parse(JSON.stringify(_this.results));
                _this.dataSource.sort(function (a, b) {
                    if (a.property > b.property) {
                        return 1;
                    }
                    else if (a.property < b.property) {
                        return -1;
                    }
                    else {
                        return 0;
                    }
                });
                if (Array.isArray(_this.results) && _this.results.length) {
                    _this.canExport = true;
                }
                _this.resulIsLoading = false;
            }
            else {
                _this.resulIsLoading = false;
                _this.toastrService.error(res.message);
            }
        }));
    };
    /**
     * Handle table sort
     *
     * @since 1.0.0
     */
    SearchDocsListV2Component.prototype.sortData = function () {
        var _this = this;
        var data = JSON.parse(JSON.stringify(this.dataSource));
        if (!this.sort.active || this.sort.direction === "") {
            return;
        }
        this.dataSource = data.sort(function (a, b) {
            var isAsc = _this.sort.direction === "asc";
            switch (_this.sort.active) {
                case "property":
                    return _this.compare(a.property, b.property, isAsc);
                case "masterCode":
                    return _this.compare(a.masterCode, b.masterCode, isAsc);
                case "docType":
                    return _this.compare(a.docType, b.docType, isAsc);
                case "content":
                    return _this.compare(a.content, b.content, isAsc);
                case "structure":
                    return _this.compare(a.structure, b.structure, isAsc);
                case "reference":
                    return _this.compare(a.reference, b.reference, isAsc);
                case "documentDate":
                    return _this.compare(a.documentDate, b.documentDate, isAsc);
                case "dateExpired":
                    return _this.compare(a.expirationDate, b.expirationDate, isAsc);
                case "barCode":
                    return _this.compare(a.barCode, b.barCode, isAsc);
                default:
                    return 0;
            }
        });
    };
    /**
     * Utility per table sort
     *
     * @since 1.0.0
     */
    SearchDocsListV2Component.prototype.compare = function (a, b, isAsc) {
        return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    };
    /**
     * Utility: export results to excel
     *
     * @since 1.0.0
     */
    SearchDocsListV2Component.prototype.onExportToExcel = function () {
        var _this = this;
        var maxPropertyColLength = 0;
        var maxTypeColLength = 0;
        var maxContentColLength = 0;
        var maxReferenceColLength = 0;
        var workbook = new Workbook();
        var worksheet = workbook.addWorksheet("Sheet");
        var header = [
            this.translateService.instant("properties.documents.searchDocs.property"),
            this.translateService.instant("properties.documents.searchDocs.type"),
            this.translateService.instant("properties.documents.searchDocs.plant"),
            this.translateService.instant("properties.documents.searchDocs.content"),
            this.translateService.instant("properties.documents.searchDocs.reference"),
            this.translateService.instant("properties.documents.searchDocs.date"),
            this.translateService.instant("properties.documents.searchDocs.expired"),
            this.translateService.instant("properties.documents.searchDocs.loaded"),
            this.translateService.instant("properties.documents.searchDocs.barCode"),
        ];
        worksheet.addRow(header);
        worksheet.lastRow.height = 37.45; // Altezza riga 25
        worksheet.lastRow.alignment = {
            horizontal: "center",
            vertical: "middle",
            wrapText: true,
        };
        worksheet.lastRow.font = {
            size: 7,
        };
        var widths = [30, 40, 40, 40, 30, 12, 12, 18, 18];
        widths.forEach(function (val, index) {
            worksheet.getColumn(index + 1).width = val;
        });
        worksheet.getRow(1).eachCell({ includeEmpty: true }, function (cell) {
            worksheet.getCell(cell.address).fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FF87CEEB" },
            };
        });
        // BEGIN - Print settings
        // Set horizontal page orientation
        worksheet.pageSetup = {
            orientation: "landscape",
            paperSize: 9,
            showGridLines: true,
        };
        // Set page header/footer
        worksheet.headerFooter.oddHeader = "&LArchedi&RStampato il " + moment().format("DD/MM/YYYY");
        worksheet.headerFooter.oddFooter = "&L" + this.translateService.instant("properties.documents.searchDocs.exportFileName") + "&RPage &P/&N";
        // END - Print settings
        var rowCount = 1;
        this.dataSource.forEach(function (el) {
            if (el.property && el.property.length > maxPropertyColLength) {
                maxPropertyColLength = el.property.length + 5;
            }
            if (el.docType && el.docType.length > maxTypeColLength) {
                maxTypeColLength = el.docType.length;
            }
            if (el.content && el.content.length > maxContentColLength) {
                maxContentColLength = el.content.length;
            }
            if (el.reference && el.reference.length > maxReferenceColLength) {
                maxReferenceColLength = el.reference.length + 5;
            }
            rowCount++;
            var type = "";
            if (el.docType) {
                type = el.docType;
                if (el.expired) {
                    type = type + "\n            " + _this.translateService.instant(el.privacy
                        ? "searchDocs.resultFields.tagSuperato"
                        : "searchDocs.resultFields.tagExpired");
                }
            }
            var row = worksheet.addRow([
                el.property ? el.property : "",
                type,
                el.structure ? el.structure : "",
                el.content ? el.content : "",
                el.reference ? el.reference : "",
                el.documentDate && moment(el.documentDate).isValid()
                    ? formatDate(el.documentDate, "dd/MM/yyyy", _this.lang)
                    : undefined,
                el.expirationDate && moment(el.expirationDate).isValid()
                    ? formatDate(el.expirationDate, "dd/MM/yyyy", _this.lang)
                    : undefined,
                el.loaded && moment(el.loaded).isValid()
                    ? formatDate(el.loaded, "dd/MM/yyyy HH:mm:ss", _this.lang)
                    : undefined,
                el.barCode,
            ]);
            if (el.mandatory && !el.expired && _this.helperService.isDocumentDataPopulated(el.data)) {
                // verde
                worksheet.lastRow.font = {
                    size: 7,
                    color: { argb: "FF28a745" },
                };
            }
            if (el.mandatory && !el.expired && !_this.helperService.isDocumentDataPopulated(el.data)) {
                // rosso
                worksheet.lastRow.font = {
                    size: 7,
                    color: { argb: "FFdc3545" },
                };
            }
            if (!el.mandatory || el.expired) {
                worksheet.lastRow.font = {
                    size: 7,
                };
                // nero
            }
            var maxLine = 1;
            for (var i = 1; i <= widths.length; i++) {
                if (i === 1) {
                    worksheet.lastRow.getCell(i).alignment = {
                        horizontal: "left",
                        indent: 0,
                        vertical: "middle",
                        wrapText: true,
                    };
                }
                else {
                    worksheet.lastRow.getCell(i).alignment = {
                        horizontal: "left",
                        indent: 1,
                        vertical: "middle",
                        wrapText: true,
                    };
                }
                var cellText = worksheet.lastRow.getCell(i).value;
                var value = -1;
                if (cellText) {
                    value =
                        Math.ceil(worksheet.lastRow.getCell(i).value.toString().length /
                            widths[i - 1]) - 1;
                    var countLine = (worksheet.lastRow
                        .getCell(i)
                        .value.toString()
                        .match(/(?:\r\n|\r|\n)/g) || []).length;
                    if (countLine > value) {
                        value = countLine;
                    }
                }
                if (value > maxLine) {
                    maxLine = value;
                }
                worksheet.lastRow.height = 22.45 * maxLine; // 22.45 = altezza riga 15
            }
        });
        // Save to file
        var date = formatDate(new Date(), "yyyyMMddhhmmss", this.lang);
        var fileName = this.translateService.instant("properties.documents.searchDocs.exportFileName") + " " + date + ".xlsx";
        workbook.xlsx.writeBuffer().then(function (data) {
            var blob = new Blob([data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            FileSaver.saveAs(blob, fileName);
        });
        this.toastrService.success(this.translateService.instant("properties.documents.searchDocs.exportedSuccessfully"));
    };
    /**
     * Handle click show documents expired
     *
     * @since 1.0.0
     */
    SearchDocsListV2Component.prototype.onShowDocsExpired = function () {
        this.showDocumentsExpired = true;
        if (!this.showDocumentsMandatory) {
            this.dataSource = this.results.filter(function (el) { return el.data; });
        }
        else {
            this.dataSource = JSON.parse(JSON.stringify(this.results));
        }
        this.sortData();
    };
    /**
     * Handle click hide documents expired
     *
     * @since 1.0.0
     */
    SearchDocsListV2Component.prototype.onHideDocsExpired = function () {
        this.showDocumentsExpired = false;
        if (!this.showDocumentsMandatory) {
            this.dataSource = this.results.filter(function (el) { return !el.expired && el.data; });
        }
        else {
            this.dataSource = this.results.filter(function (el) { return !el.expired; });
        }
        this.sortData();
    };
    /**
     * Handle click show documents expired
     *
     * @since 1.0.0
     */
    SearchDocsListV2Component.prototype.onShowDocsMandatory = function () {
        this.showDocumentsMandatory = true;
        if (!this.showDocumentsExpired) {
            this.dataSource = this.results.filter(function (el) { return !el.expired; });
        }
        else {
            this.dataSource = JSON.parse(JSON.stringify(this.results));
        }
        this.sortData();
    };
    /**
     * Handle click hide documents expired
     *
     * @since 1.0.0
     */
    SearchDocsListV2Component.prototype.onHideDocsMandatory = function () {
        this.showDocumentsMandatory = false;
        if (!this.showDocumentsExpired) {
            this.dataSource = this.results.filter(function (el) { return !el.expired && el.data; });
        }
        else {
            this.dataSource = this.results.filter(function (el) { return el.data; });
        }
        this.sortData();
    };
    /**
     * Handle click on document form to download file
     *
     * @since 1.0.0
     */
    SearchDocsListV2Component.prototype.onDownloadDocument = function (propertyId, documents) {
        if (!documents || !documents.length) {
            console.warn("ERROR: NO DOCS");
            return;
        }
        this.dialog.open(DocumentDownloadDialogComponent, {
            data: {
                propertyId: propertyId,
                documents: documents,
            },
            width: "600px",
        });
    };
    /**
     * Handle click on document and open dialog box to edit/show document data
     * and upload document file
     * modalTitle: title of dialogbox from document name
     * documentKey: doc type, es. AA1, AA2, etc.
     * documentId: the ID of document into array of documentArchive section (es. gestAmmTivoDipendenti)
     * subDocumentId: the ID of sub document into array of docs type (es. AA1)
     * itemData: data value of form items
     * action: edit or show doc data
     *
     * @since 1.0.0
     */
    SearchDocsListV2Component.prototype.onToggleEditShowDocument = function (documentArchiveId, modalTitle, documentKey, documentId, subDocumentId, itemData, action, documentFather, keyTranslateTitle, structureId, expired, contractPdfMsg, companyCode, propertyCode) {
        var _this = this;
        // if (this.subscriptionType === "FREE") {
        //   documentId = "undefined";
        // }
        // Create formly default fields
        var defaultFields = [
            {
                className: "col-12 col-md-12 col-xl-12",
                type: "textarea",
                key: "contenutoDocumento",
                templateOptions: {
                    label: this.translateService.instant("properties.detail.documentArchive.fields.contenutoDocumento"),
                    placeholder: this.translateService.instant("properties.detail.documentArchive.fields.contenutoDocumento"),
                    required: true,
                    minLength: 2,
                    maxLength: 500,
                    rows: 5,
                    disabled: action === "show" ? true : false,
                },
            },
            {
                className: "col-12 col-md-12 col-xl-12",
                type: "input",
                key: "protocollo",
                templateOptions: {
                    readonly: false,
                    label: this.translateService.instant("properties.detail.documentArchive.fields.protocollo"),
                    placeholder: this.translateService.instant("properties.detail.documentArchive.fields.protocollo"),
                    required: false,
                    minLength: 0,
                    maxLength: 500,
                },
            },
            {
                className: "col-12 col-md-12 col-xl-12",
                type: "textarea",
                key: "keyword",
                templateOptions: {
                    readonly: false,
                    label: this.translateService.instant("properties.detail.documentArchive.fields.keyword"),
                    placeholder: this.translateService.instant("properties.detail.documentArchive.fields.keyword"),
                    required: false,
                    minLength: 0,
                    maxLength: 1000,
                    rows: 3,
                },
            },
        ];
        // create fields formly from document key: es AA1
        // const aryfields = this.documentTypeStructure.getFormlyFields(
        //   documentKey,
        //   false
        // );
        var schemaType = JSON.parse(JSON.stringify(this.documentTypeStructure.getDocumentType2(documentKey, this.documentTemplate)));
        var aryfields = this.documentTypeStructure.getFormlyFields2(schemaType, false);
        aryfields.forEach(function (item) {
            if (item.templateOptions && item.templateOptions.placeholder) {
                item.templateOptions.placeholder = _this.translateService.instant(item.templateOptions.placeholder);
            }
            if (item.type === "select") {
                if (Array.isArray(item.templateOptions.options)) {
                    item.templateOptions.options.forEach(function (subItem) {
                        subItem.label = _this.translateService.instant(subItem.label);
                    });
                }
            }
            if (item.type === "selectNew") {
                item.type = "autocomplete";
                if (item.templateOptions.initialValues) {
                    var options_1 = [];
                    switch (item.templateOptions.initialValues) {
                        case "suppliersName":
                            _this.suppliersName.forEach(function (subItem) {
                                // options.push({
                                //   value: subItem,
                                //   label: subItem,
                                // });
                                options_1.push(subItem);
                            });
                            break;
                        case "yearsOfStorage":
                            _this.yearsOfStorage.forEach(function (subItem) {
                                // options.push({
                                //   value: subItem,
                                //   label: subItem,
                                // });
                                options_1.push(subItem);
                            });
                            break;
                        case "conductorName":
                            _this.conductorName.forEach(function (subItem) {
                                // options.push({
                                //   value: subItem,
                                //   label: subItem,
                                // });
                                options_1.push(subItem);
                            });
                            break;
                        case "nameInterventionArchiving":
                            _this.nameInterventionArchiving.forEach(function (subItem) {
                                // options.push({
                                //   value: subItem,
                                //   label: subItem,
                                // });
                                options_1.push(subItem);
                            });
                            break;
                    }
                    item.templateOptions.initialValues = options_1;
                    item.templateOptions.addTagText = _this.translateService.instant(item.templateOptions.addTagText);
                    item.templateOptions.customLabel = _this.translateService.instant(item.templateOptions.customLabel);
                }
            }
            if (item.type === "autocomplete" ||
                item.type === "autocomplete-supplier") {
                item.templateOptions.addTagText = _this.translateService.instant(item.templateOptions.addTagText);
                item.templateOptions.customLabel = _this.translateService.instant(item.templateOptions.customLabel);
                if (item.templateOptions.search$ === "suppliersService") {
                    item.templateOptions.search$ =
                        _this.suppliersService.getListV2.bind(_this);
                }
            }
            else {
                if (item.templateOptions && item.templateOptions.label) {
                    item.templateOptions.label = _this.translateService.instant(item.templateOptions.label);
                }
            }
            if (action === "show" && item.templateOptions) {
                item.templateOptions.disabled = true;
            }
        });
        // const contract = this.documentTypeStructure.isContract(documentKey);
        var contract = this.documentTypeStructure.isContract2(documentKey, this.documentTemplate);
        var fieldGroup = aryfields.concat(defaultFields);
        var itemConfig = [
            {
                fieldGroupClassName: "row",
                fieldGroup: fieldGroup,
            },
        ];
        var barCode = "";
        if (itemData && itemData.barCode) {
            barCode = itemData.barCode;
        }
        // const selectedArea =
        //   this.documentTypeStructure.getAreaFromChild(keyTranslateTitle);
        var selectedArea = this.documentTypeStructure.getAreaFromChild2(keyTranslateTitle, this.documentTemplate);
        var title = "";
        if (keyTranslateTitle) {
            title = keyTranslateTitle.split("properties.documents.")[1];
        }
        var dialogRef = this.dialog.open(PropertyDetailDocumentItemDialogComponent, {
            data: {
                modalTitle: modalTitle,
                documentArchiveId: documentArchiveId,
                documentTypeRoute: this.documentTypeStructure.getDocRoute2(documentKey, this.documentTemplate),
                documentId: documentId,
                documentKey: documentKey,
                subDocumentId: subDocumentId,
                itemData: itemData,
                itemConfig: itemConfig,
                propertyCode: propertyCode,
                companyCode: companyCode,
                barCode: barCode,
                action: action,
                documentFather: documentFather,
                keyTranslateTitle: title,
                structureId: structureId !== "" ? structureId : undefined,
                contract: contract,
                expired: expired,
                contractPdfMsg: contractPdfMsg,
                selectedArea: selectedArea,
                property: "",
                companyData: "",
                propertyName: "",
            },
            width: "700px",
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                // return;
            }
            else {
                if (res === "reload") {
                    _this.onSubmit();
                }
            }
        }, function (err) {
            _this.helperService.handleError(err);
        });
    };
    /**
     * Handle delete document
     *
     * @since 1.0.0
     */
    SearchDocsListV2Component.prototype.onDeleteDocument = function (item) {
        var _this = this;
        var dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: this.translateService.instant("searchDocs.dialogs.deleteDoc.title"),
                message: this.translateService.instant("searchDocs.dialogs.deleteDoc.text", {
                    doc: item.docType,
                    property: item.property,
                }),
                btnOkText: this.translateService.instant("common.cta.confirm"),
                btnCancelText: this.translateService.instant("common.cta.close"),
            },
            width: "500px",
        });
        dialogRef.afterClosed().subscribe(function (res) {
            if (res) {
                _this.resulIsLoading = true;
                var sendData = {
                    docs: item.id,
                    mockup: item.mockup,
                };
                _this.subscriptions.push(_this.documentArchivesService
                    .deleteDocs(item.documentArchiveId, sendData)
                    // .pipe(finalize(() => (this.formBtnOptions.active = false)))
                    .subscribe(function (res) {
                    if (res.status) {
                        _this.toastrService.success(res.message);
                        _this.results = _this.results.filter(function (el) { return el.id.toString() !== item.id.toString(); });
                        _this.dataSource = _this.dataSource.filter(function (el) { return el.id.toString() !== item.id.toString(); });
                        _this.resulIsLoading = false;
                    }
                }, function (err) {
                    _this.toastrService.error(_this.translateService.instant(err));
                    _this.resulIsLoading = false;
                }));
            }
        });
    };
    /**
     * Handle click on document form to cancel contract
     *
     * @since 1.0.0
     */
    SearchDocsListV2Component.prototype.onCancelContractDialogOpen = function (documentArchiveId, propertyName, propertyId, modalTitle, itemData) {
        var _this = this;
        var contract = tslib_1.__assign({}, itemData, { documentArchiveId: documentArchiveId, title: modalTitle, companyData: "", propertyName: propertyName, propertyId: propertyId });
        // Open dialog
        var dialogRef = this.cancelContractDialog.open(CancelContractDialogComponent, {
            minWidth: "60%",
            maxHeight: "98vh",
            data: {
                contract: contract,
                subject: this.translateService.instant("communications.fields.cancelContractSubject"),
                body: this.translateService.instant("communications.fields.cancelContractImmediateBody", { title: modalTitle.trim() }),
            },
            disableClose: true,
        });
        // On dialog closing, let's update model
        this.subscriptions.push(dialogRef.afterClosed().subscribe(function (res) {
            if (res) {
                var sendData = {
                    msg: res,
                };
                _this.subscriptions.push(_this.documentArchivesService
                    .cancelContract(documentArchiveId, sendData)
                    .pipe(take(1))
                    .subscribe(function (res) {
                    console.log(res);
                    if (!res) {
                        return;
                    }
                    else {
                        _this.onSubmit();
                    }
                }, function (err) {
                    _this.helperService.handleError(err);
                }));
            }
        }, function (err) {
            _this.helperService.handleError(err);
        }));
    };
    /**
     * Handle click on document form to expire contract
     *
     * @since 1.0.0
     */
    SearchDocsListV2Component.prototype.onHandleExpiredContract = function (documentArchiveId, itemData) {
        var _this = this;
        var dialogRef = this.dialog.open(PropertyExpireContractItemDialogComponent, {
            data: {
                documentArchiveId: documentArchiveId,
                barCode: itemData.barCode ? itemData.barCode : "",
            },
            width: "600px",
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            else {
                // @TODO aggironare la tabella
            }
        }, function (err) {
            _this.helperService.handleError(err);
        });
    };
    return SearchDocsListV2Component;
}());
export { SearchDocsListV2Component };
